import DiscussionsList from './DiscussionsList';

export default DiscussionsList;
